module.exports = __webpack_public_path__ + "img/2. Target Logistic_2.652e9f0b.jpg";